<!-- @format -->

<sis-page-title [title]="'OPEN_UNIVERSITY.STUDIES_ACTIVATE_WIZARD.STEP3.TITLE' | translate" [dataCy]="'activate-wizard-title-step-3'" />
<sis-wizard-progress [stepKeys]="wizardProgressStepKeys" [currentStep]="2"></sis-wizard-progress>
<div class="row col-12 sis-my-sm">
  <p>{{ "OPEN_UNIVERSITY.STUDIES_ACTIVATE_WIZARD.STEP3.DESC" | translate }}</p>
  @if (isStaffUser) {
    <p data-cy="activate-wizard-step-3-staff-user-desc">
      {{ "OPEN_UNIVERSITY.STUDIES_ACTIVATE_WIZARD.STEP3.STAFF_USER_DESC" | translate }}
    </p>
  }
</div>
@for (cartItem of openUniversityCart.items; track cartItem) {
  <app-open-university-enrolled-item-info
    [cartItem]="cartItem"
    [openUniversityCart]="openUniversityCart"
    [openUniversityProducts]="openUniversityProducts"
    [courseUnits]="courseUnits"
    [assessmentItemsData]="assessmentItemsData" />
}
@if (!isSuomiFiPath) {
  <sis-wizard-step-buttons
    [forwardButtonTitle]="'OPEN_UNIVERSITY.STUDIES_ACTIVATE_WIZARD.STEP3.CONFIRM_BUTTON' | translate"
    [backButtonDisplay]="false"
    (forward)="goToFrontPage()" />
}
@if (isSuomiFiPath) {
  <fudis-heading [level]="2" [variant]="'lg'" class="fudis-mt-md">
    {{ "OPEN_UNIVERSITY.STUDIES_ACTIVATE_WIZARD.STEP3.SUOMI_FI.TITLE" | translate }}
  </fudis-heading>
  <div class="sis-my-sm">
    <fudis-body-text [variant]="'md-light'">{{
      "OPEN_UNIVERSITY.STUDIES_ACTIVATE_WIZARD.STEP3.SUOMI_FI.DESC1" | translate
    }}</fudis-body-text>
    <fudis-body-text [variant]="'md-light'">{{
      "OPEN_UNIVERSITY.STUDIES_ACTIVATE_WIZARD.STEP3.SUOMI_FI.DESC2" | translate
    }}</fudis-body-text>
    <fudis-body-text [variant]="'md-light'">{{
      "OPEN_UNIVERSITY.STUDIES_ACTIVATE_WIZARD.STEP3.SUOMI_FI.DESC3" | translate
    }}</fudis-body-text>
  </div>
  <hr class="sis-hr" />
  <sis-button class="suomi-fi-activate-button" data-cy="suomi-fi-activate-button" [naked]="true" (clicked)="goToSearch()">
    {{ "OPEN_UNIVERSITY.STUDIES_ACTIVATE_WIZARD.STEP3.SUOMI_FI.CONFIRM_BUTTON" | translate }}
  </sis-button>
}
